import store from "../store/configureStore";

export const userHaveRole = (role?: string): boolean => {
	if (role === undefined) return true;
	const userRoles = store.getState().user.userRoles;
	return userRoles.some((x) => x.toLocaleLowerCase() === role.toLocaleLowerCase());
};
